import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $16805b1b18093c5f$export$de3fdf6493c353d = /*#__PURE__*/function (_Symbol$iterator) {
  function $16805b1b18093c5f$export$de3fdf6493c353d(opts) {
    var _this = this;

    _classCallCheck(this, $16805b1b18093c5f$export$de3fdf6493c353d);

    this.keyMap = new Map();
    this.keyMap = new Map();
    this.columnCount = opts === null || opts === void 0 ? void 0 : opts.columnCount;
    this.rows = [];

    var _visit = function visit(node) {
      // If the node is the same object as the previous node for the same key,
      // we can skip this node and its children. We always visit columns though,
      // because we depend on order to build the columns array.
      var prevNode = _this.keyMap.get(node.key);

      if (opts.visitNode) node = opts.visitNode(node);

      _this.keyMap.set(node.key, node);

      var childKeys = new Set();
      var last = null;
      var rowHasCellWithColSpan = false;

      if (node.type === 'item') {
        var _child_props;

        var _iterator = _createForOfIteratorHelper(node.childNodes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;

            if (((_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.colSpan) !== undefined) {
              rowHasCellWithColSpan = true;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var _iterator2 = _createForOfIteratorHelper(node.childNodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _child2 = _step2.value;

          if (_child2.type === 'cell' && rowHasCellWithColSpan) {
            var _child_props1, _child_props2;

            _child2.colspan = (_child_props1 = _child2.props) === null || _child_props1 === void 0 ? void 0 : _child_props1.colSpan;
            _child2.colSpan = (_child_props2 = _child2.props) === null || _child_props2 === void 0 ? void 0 : _child_props2.colSpan;

            var _last_colIndex, _last_colSpan;

            _child2.colIndex = !last ? _child2.index : ((_last_colIndex = last.colIndex) !== null && _last_colIndex !== void 0 ? _last_colIndex : last.index) + ((_last_colSpan = last.colSpan) !== null && _last_colSpan !== void 0 ? _last_colSpan : 1);
          }

          if (_child2.type === 'cell' && _child2.parentKey == null) // if child is a cell parent key isn't already established by the collection, match child node to parent row
            _child2.parentKey = node.key;
          childKeys.add(_child2.key);

          if (last) {
            last.nextKey = _child2.key;
            _child2.prevKey = last.key;
          } else _child2.prevKey = null;

          _visit(_child2);

          last = _child2;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (last) last.nextKey = null; // Remove deleted nodes and their children from the key map

      if (prevNode) {
        var _iterator3 = _createForOfIteratorHelper(prevNode.childNodes),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _child = _step3.value;
            if (!childKeys.has(_child.key)) _remove(_child);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    };

    var _remove = function remove(node) {
      _this.keyMap.delete(node.key);

      var _iterator4 = _createForOfIteratorHelper(node.childNodes),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          if (_this.keyMap.get(child.key) === child) _remove(child);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    };

    var last = null;

    var _iterator5 = _createForOfIteratorHelper(opts.items.entries()),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _step5$value2 = _slicedToArray(_step5.value, 2),
            i = _step5$value2[0],
            node = _step5$value2[1];

        var _node_level, _node_key, _node_type, _node_value, _node_textValue, _node_index;

        var rowNode = _objectSpread(_objectSpread({}, node), {}, {
          level: (_node_level = node.level) !== null && _node_level !== void 0 ? _node_level : 0,
          key: (_node_key = node.key) !== null && _node_key !== void 0 ? _node_key : 'row-' + i,
          type: (_node_type = node.type) !== null && _node_type !== void 0 ? _node_type : 'row',
          value: (_node_value = node.value) !== null && _node_value !== void 0 ? _node_value : null,
          hasChildNodes: true,
          childNodes: _toConsumableArray(node.childNodes),
          rendered: node.rendered,
          textValue: (_node_textValue = node.textValue) !== null && _node_textValue !== void 0 ? _node_textValue : '',
          index: (_node_index = node.index) !== null && _node_index !== void 0 ? _node_index : i
        });

        if (last) {
          last.nextKey = rowNode.key;
          rowNode.prevKey = last.key;
        } else rowNode.prevKey = null;

        this.rows.push(rowNode);

        _visit(rowNode);

        last = rowNode;
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    if (last) last.nextKey = null;
  }

  return _createClass($16805b1b18093c5f$export$de3fdf6493c353d, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield(_toConsumableArray(this.rows), "t0", 1);

          case 1:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return _toConsumableArray(this.rows).length;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);

      var _node_prevKey;

      return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);

      var _node_nextKey;

      return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var _;

      return (_ = _toConsumableArray(this.rows)[0]) === null || _ === void 0 ? void 0 : _.key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var _rows_;

      var rows = _toConsumableArray(this.rows);

      return (_rows_ = rows[rows.length - 1]) === null || _rows_ === void 0 ? void 0 : _rows_.key;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var _this_keyMap_get;

      return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
  }, {
    key: "at",
    value: function at(idx) {
      var keys = _toConsumableArray(this.getKeys());

      return this.getItem(keys[idx]);
    }
  }, {
    key: "getChildren",
    value: function getChildren(key) {
      var node = this.keyMap.get(key);
      return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
  }]);
}(Symbol.iterator);

export { $16805b1b18093c5f$export$de3fdf6493c353d as GridCollection };